<template>
  <div>
    <div class="flex flex-col" v-if="towns">
      <div class="flex flex-col items-start mt-8 space-y-1 text-gray-700">
        <p class="pb-1 font-semibold text-start">Popular Searches</p>
        <button
          @click="getProperties(property_type.id, propertyAction)"
          v-for="property_type in filteredPropertyTypes"
          :key="property_type.id"
          class="text-sm text-start hover:underline"
        >
          {{ property_type.name }} {{ propertyAction }}
        </button>

        <div class="w-56 py-2 border-b border-gray-300"></div>
      </div>
      <div
        class="flex flex-col items-start mt-8 space-y-1 text-gray-700"
        v-if="towns"
      >
        <p class="pb-1 font-semibold text-start">Nearby Areas</p>
        <button
          v-for="town in towns"
          :key="town.id"
          class="text-sm text-start hover:underline"
        >
          Properties {{ propertyAction }} in {{ town.name }}
        </button>

        <div class="w-56 py-2 border-b border-gray-300"></div>
      </div>
      <div class="flex flex-col items-start mt-8 space-y-1 text-gray-700">
        <p class="pb-1 font-semibold text-start">Properties for Rent</p>
        <router-link
          :to="{
            name: 'properties',
            params: { slug: 'properties-for-rent' },
          }"
          @click="setActiveLink('rent')"
          v-if="$route.path !== '/properties/properties-for-rent'"
          href=""
          class="text-sm text-start hover:underline"
        >
          Properties for rent
        </router-link>
        <router-link
          :to="{
            name: 'properties',
            params: { slug: 'properties-for-sale' },
          }"
          @click="setActiveLink('buy')"
          v-else-if="$route.path !== '/properties/properties-for-sale'"
          href=""
          class="text-sm text-start hover:underline"
        >
          Properties for sale
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  name: "PropertiesView",

  setup() {
    const router = useRouter();
    const store = useStore();
    const base_url = store.state.baseUrl;
    const property_types = ref([]);
    const towns = ref("");
    const activeLink = ref(null);

    const getPropertyTypes = () => {
      axios
        .get(`${base_url}property-types`)
        .then((response) => {
          property_types.value = response.data.data;
        })
        .catch((error) => console.log(error));
    };

    const getTowns = () => {
      axios
        .get(`${base_url}towns`)
        .then((response) => {
          towns.value = response.data;
        })
        .catch((error) => console.log(error));
    };

    // Compute the property action based on the route path
    const propertyAction = computed(() => {
      const path = router.currentRoute.value.path;
      if (path === "/properties/properties-for-rent") {
        return "for rent";
      } else if (path === "/properties/properties-for-sale") {
        return "for sale";
      } else if (path === "/properties/properties-for-short-stay") {
        return "for short stay";
      }
      return "for commercial rent";
    });

    // Filter the property types based on the route path
    const filteredPropertyTypes = computed(() => {
      const path = router.currentRoute.value.path;
      return property_types.value.filter((property_type) => {
        const lowerName = property_type.name.toLowerCase();
        if (path === "/properties/properties-for-sale") {
          return (
            !lowerName.includes("rent") &&
            !lowerName.includes("office") &&
            !lowerName.includes("hotel")
          );
        } else if (path === "/properties/properties-for-rent") {
          return lowerName.includes("hotel") || !lowerName.includes("office");
        } else if (path === "/commercial-properties") {
          return lowerName.includes("office");
        }
        return true;
      });
    });

    const setActiveLink = (link) => {
      activeLink.value = link;
      localStorage.setItem("activeLink", link);
    };

    const getProperties = (propertyTypeId) => {
      const tenure = propertyAction.value.split(" ")[1];
      // const path = router.currentRoute.value.path;
      // let tenure_name = "";
      // if (path === "/properties/properties-for-rent") {
      //   tenure_name = "Rent";
      // } else if (path === "/properties/properties-for-sale") {
      //   tenure_name = "Buy";
      // }
      const queryParams = {
        // property_tenure_option_name: tenure_name,
        property_type_id: propertyTypeId,
      };

      router.push({
        name: "properties",
        params: { slug: `properties-for-${tenure}` },
        query: queryParams,
      });
    };

    onMounted(() => {
      getPropertyTypes();
      getTowns();
    });

    return {
      property_types,
      towns,
      getProperties,
      filteredPropertyTypes,
      propertyAction,
      setActiveLink,
    };
  },
};
</script>
